module.exports = __webpack_public_path__ + "static/media/img5.ce87b29d.jpg";